module.exports = __webpack_public_path__ + "media/images/front/icon_dba-4b0166af8947e3bdc3329c8f838f801a.png";